export default "__VITE_ASSET__Dvx8FYQM__"